import { InjectionToken } from '@angular/core';
import { PageState } from '../interfaces/page-state.interface';

/**
 * No root factory: the implementation lives in the layout domain. Layout
 * registers it on the root injector.
 */
export const PAGE = new InjectionToken<PageState>('PageState');
